import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { API, api } from "@/lib/api";
import { StepNav } from "@/components/wizard/Stepper";

export const stickerSrc = (order, template) =>
  `${API}/orders/${order.order_id}/sticker.png?template=${template || order.template || "classic_scrapbook"}&title=${encodeURIComponent(order.title || "")}&v=${encodeURIComponent(order.updated_at || "")}`;

export const StepSticker = ({ order, go, back }) => {
  const [templates, setTemplates] = useState([]);
  const [choice, setChoice] = useState(order.template === "christmas" ? null : order.template);
  useEffect(() => { api.get("/templates").then(({ data }) => setTemplates(data)); }, []);
  return (
    <div>
      <h2 className="text-3xl font-bold text-[#4A2A18]">Choose your design</h2>
      <p className="mt-3 text-lg text-[#4A3B32]">Your design goes on your sticker sheet and ornament, with your title and your own QR code. Tap the one you like.</p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2" role="radiogroup">
        {templates.map((t) => (
          <button key={t.id} type="button" role="radio" aria-checked={choice === t.id} onClick={() => setChoice(t.id)}
            className={`relative rounded-2xl border-4 bg-white p-4 text-left transition-colors ${choice === t.id ? "border-[#A83232]" : "border-[#E6DEC6] hover:border-[#C86446]"}`}
            data-testid={`template-option-${t.id}`}>
            {choice === t.id && <CheckCircle2 className="absolute right-3 top-3 z-10 rounded-full bg-white text-[#A83232]" size={32} />}
            <img src={stickerSrc(order, t.id)} alt={`${t.name} sticker preview`} className="w-full rounded-lg shadow-md" />
            <p className="mt-4 font-serif text-2xl font-semibold text-[#2C1E16]">{t.name}</p>
            <p className="mt-1 text-base text-[#5C4A3E]">{t.blurb}</p>
          </button>
        ))}
      </div>
      <StepNav back={back} next={() => go(5, { template: choice })} disabled={!choice} />
    </div>
  );
};
